module.exports = __webpack_public_path__ + "static/media/Shyam Aradhye.61673cec.png";